import { type FC, useEffect, useState } from 'react';
import styles from './BoostModal.module.css';
import { useModalStore } from '../../store/ModalStore';
import { useBoostTaskStore } from '../../store/BoostStore';
import { AdServiceManager } from '../../AdService/AdServiseManager';
import AdWidgetModal from '../../AdService/TadsModal/TadsWM';
// import { postCPCBannerClick } from '@/api/modules/Tasks/flyer_cpc';
// import { sendBarzhaClick } from '@/api/modules/Tasks/barzha';

export interface BoostTask {
  id: string | number;
  title?: string;
  description?: string;
  icon?: string;
  provider: string;
  link?: string;
  onClick: () => Promise<'success' | 'user_cancelled' | 'ads_not_found'>;
  onShowReward?: () => Promise<boolean>;
}

export interface BoostProvider {
  getName(): string;
  getAvailableTasks(miningId: number): Promise<BoostTask[]>;
  startTask?(
    taskId: string | number,
  ): Promise<'success' | 'user_cancelled' | 'ads_not_found'>;
  resetError?(): void;
}

const BoostModal: FC = () => {
  const [task, setTask] = useState<BoostTask | null>(null);
  const [loading, setLoading] = useState(false);
  const { open, setOpen, setClosing, source } = useModalStore();
  const { currentTask, setCurrentTask } = useBoostTaskStore();

  useEffect(() => {
    if (open) {
      console.log('BoostModal opened from:', source);
      if (currentTask) {
        setTask(currentTask);
        setLoading(false);
      } else {
        loadTask();
      }
    }

    return () => {
      setCurrentTask(null); // Очищаем стор при закрытии
    };
  }, [open, source]);

  const loadTask = async () => {
    setLoading(true);
    try {
      const providers = AdServiceManager.getProviders();

      for (const provider of providers) {
        if (provider.getName() === 'Tads') continue;
        if (provider.getName() === 'AdsgramCPC') continue;
        const tasks = await provider.getAvailableTasks();

        if (tasks?.length) {
          const firstTask = tasks[0];
          setTask(firstTask);
          setCurrentTask(firstTask);
          break;
        }
      }
    } catch (error) {
      console.error('Ошибка загрузки заданий:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setClosing(true);
    setTimeout(() => setOpen(false), 300);
  };

  const handleTaskClick = async () => {
    if (!task) return;

    try {
      handleClose();
      const result = await task.onClick();

      if (result === 'success') {
        // if (task.provider === 'Flyer') {
        //   const res = await postCPCBannerClick(task.id as string);
        //   console.log(res.data.task.user_progress, 'progres');
        //   setTimeout(() => {
        //     setNotification({
        //       type: 'Success',
        //       message: 'Прогресс засчитан',
        //     });
        //   }, 1000);
        // }
        // if (task.provider === 'Barza') {
        //   const res = await sendBarzhaClick();
        //   console.log(res.data.task.user_progress, 'progres');
        //   setTimeout(() => {
        //     setNotification({
        //       type: 'Success',
        //       message: 'Прогресс засчитан',
        //     });
        //   }, 1000);
        // }
        const providerMap: Record<string, string> = {
          TappAds: 'tappads',
          onclick: 'onclick',
          Barza: 'barzha',
          Adsgram: 'adsgram',
          Tads: 'tads',
          Flyer: 'flyer',
          RichAds: 'richads',
          DreamCoin: 'dreamcoin',
        };

        const apiProvider = providerMap[task.provider];
        if (!apiProvider) {
          console.error(`Unknown provider: ${task.provider}`);
          //   setNotification({
          //     type: 'Error',
          //     message: 'Неизвестный провайдер рекламы',
          //   });
          return;
        }
      } else if (result === 'user_cancelled') {
        console.log('Task cancelled by user');
      } else {
        // setNotification({
        //   type: 'Error',
        //   message: 'Не удалось выполнить задание',
        // });
      }
    } catch (err) {
      console.error('Error executing task:', err);
      //   setNotification({
      //     type: 'Error',
      //     message: 'Произошла ошибка при выполнении задания',
      //   });
    }
  };

  const getFirstLetter = (title: string) => {
    // Регулярное выражение для проверки эмодзи
    const emojiRegex =
      /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F900}-\u{1F9FF}]|[\u{1F018}-\u{1F270}]|[\u{238C}-\u{2454}]|[\u{20D0}-\u{20FF}]|[\u{FE00}-\u{FE0F}]|[\u{1FAB0}-\u{1FABF}]|[\u{1FAC0}-\u{1FAFF}]|[\u{1FAD0}-\u{1FAFF}]|[\u{1FAE0}-\u{1FAFF}]|[\u{1FAF0}-\u{1FAFF}]/u;

    // Проверяем, содержит ли заголовок эмодзи
    if (emojiRegex.test(title)) {
      // Если есть эмодзи, берем второй символ (пропускаем эмодзи)
      return title.slice(1, 2);
    } else {
      // Если нет эмодзи, берем первую букву
      return title.slice(0, 1);
    }
  };

  const placeholderImage = task ? (
    <div className={styles.taskIconPlaceholder}>
      {task.title ? getFirstLetter(task.title) : ''}
    </div>
  ) : (
    <div className={styles.taskIconPlaceholder}></div>
  );

  return (
    <div className={styles.boostModal}>
      {task?.provider === 'Tads' ? (
        <AdWidgetModal
          isOpen={true}
          isClosing={false}
          onClose={handleClose}
          onReward={handleTaskClick}
          onAdsNotFound={() => {
            // setNotification({
            //   type: 'Warning',
            //   message: 'Реклама не найдена, пробуем другой способ',
            // });
            handleClose();
          }}
          checkOnly={false}
        />
      ) : (
        <>
          <p className={styles.rewardText}>
            Нажми на баннер, чтобы <br /> выполнить задание
          </p>

          {loading ? (
            <div className={styles.loading}>Загрузка задания...</div>
          ) : task ? (
            <div className={styles.modalContent} onClick={handleTaskClick}>
              <div className={styles.modalContentContainer}>
                {task.icon &&
                task.icon !==
                  'https://i.ibb.co/1fL03jFC/photo-2025-06-20-13-59-47.jpg' &&
                task.provider !== 'Barza' ? (
                  <img
                    src={task.icon}
                    alt="Task Icon"
                    className={styles.taskIconModal}
                  />
                ) : (
                  placeholderImage
                )}
                <div className={styles.modalTitleContainer}>
                  <h3 className={styles.modalTitle}>{task.title}</h3>
                  <p className={styles.modalDescription}>{task.description}</p>
                </div>
              </div>
            </div>
          ) : (
            <div className={styles.noTasks}>Нет доступных заданий</div>
          )}

          <p className={styles.rewardText_warning}>
            *Остерегайтесь мошенников.
            <br />
            Подписываться необязательно.
          </p>
        </>
      )}
    </div>
  );
};

export default BoostModal;
